import {invalidateOnSuccess, omneticApi} from '@dms/api/base';

import {
  CreateBranchLeadAddressApiArg,
  CreateBranchLeadAddressApiResponse,
  ConfirmAiLeadEmailMessageApiResponse,
  ConfirmAiLeadEmailMessageApiArg,
  FailAiLeadEmailMessageApiResponse,
  FailAiLeadEmailMessageApiArg,
  GetAiLeadSettingsApiResponse,
  GetAiLeadSettingsApiArg,
  UpdateAiLeadSettingsApiResponse,
  UpdateAiLeadSettingsApiArg,
  GetAiLeadEmailMessageApiResponse,
  GetAiLeadEmailMessageApiArg,
  RetryAiLeadEmailMessageApiResponse,
  RetryAiLeadEmailMessageApiArg,
} from './types';

const aiLeadApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    confirmAiLeadEmailMessage: build.mutation<
      ConfirmAiLeadEmailMessageApiResponse,
      ConfirmAiLeadEmailMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/ai-lead/email-message/${queryArg.emailMessageId}/confirm`,
        method: 'PUT',
      }),
    }),

    failAiLeadEmailMessage: build.mutation<
      FailAiLeadEmailMessageApiResponse,
      FailAiLeadEmailMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/ai-lead/email-message/${queryArg.emailMessageId}/fail`,
        method: 'PUT',
      }),
    }),
    retryAiLeadEmailMessage: build.mutation<
      RetryAiLeadEmailMessageApiResponse,
      RetryAiLeadEmailMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/ai-lead/email-message/${queryArg.emailMessageId}/retry`,
        method: 'PUT',
      }),
    }),
    getAiLeadSettings: build.query<GetAiLeadSettingsApiResponse, GetAiLeadSettingsApiArg>({
      query: () => ({
        url: `/dms/v1/ai-lead/settings`,
      }),
      providesTags: ['AiLeadSettings'],
    }),
    updateAiLeadSettings: build.mutation<
      UpdateAiLeadSettingsApiResponse,
      UpdateAiLeadSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/ai-lead/settings`,
        method: 'PUT',
        body: queryArg,
      }),
      invalidatesTags: ['AiLeadSettings'],
    }),
    createBranchLeadAddress: build.mutation<
      CreateBranchLeadAddressApiResponse,
      CreateBranchLeadAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/ai-lead/branch-lead-address`,
        method: 'POST',
        body: queryArg,
      }),
      invalidatesTags: invalidateOnSuccess(['AiLeadSettings']),
    }),
    getAiLeadEmailMessage: build.query<
      GetAiLeadEmailMessageApiResponse,
      GetAiLeadEmailMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/ai-lead/email-message/${queryArg.id}`,
      }),
    }),
  }),
});

export const {
  useRetryAiLeadEmailMessageMutation,
  useGetAiLeadSettingsQuery,
  useGetAiLeadEmailMessageQuery,
  useLazyGetAiLeadEmailMessageQuery,
  useConfirmAiLeadEmailMessageMutation,
  useFailAiLeadEmailMessageMutation,
  useUpdateAiLeadSettingsMutation,
  useCreateBranchLeadAddressMutation,
} = aiLeadApi;
